import { render, staticRenderFns } from "./MyCoursesListPage.vue?vue&type=template&id=6056b688&scoped=true&"
import script from "./MyCoursesListPage.vue?vue&type=script&lang=js&"
export * from "./MyCoursesListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056b688",
  null
  
)

export default component.exports